import React, { useEffect, useState } from "react";
import DashboardLayout from "../components/Nav";
import toast from "react-hot-toast";
import getClientConfig from "../config";

const { API_BASE_URL } = getClientConfig();

export default function ActiveCallsPage() {
  useEffect(() => {
    document.title = "Active Calls | Voice Intelligence Portal";
  }, []);
  const token = localStorage.getItem("auth_token");
  const [calls, setCalls] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    
    fetch(`${API_BASE_URL}/voice/calls/active`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setCalls(data);
        setLoading(false);
      })
      .catch(() => {
        toast.error("Failed to load active calls");
        setLoading(false);
      });
  }, []);

  return (
    <DashboardLayout>
      <div className="p-6 max-w-7xl mx-auto">
        <h2 className="text-2xl font-bold mb-4">Active Calls</h2>

        {loading ? (
          <p className="text-gray-600">Loading...</p>
        ) : calls.length === 0 ? (
          <p className="text-gray-500">No active calls at the moment.</p>
        ) : (
          <div className="overflow-x-auto shadow rounded-xl ring-1 ring-gray-200">
            <table className="w-full text-sm text-left bg-white">
              <thead className="bg-gray-100 text-gray-700">
                <tr>
                  <th className="px-6 py-4">Call ID</th>
                  <th className="px-6 py-4">From</th>
                  <th className="px-6 py-4">To</th>
                  <th className="px-6 py-4">Start Time</th>
                  <th className="px-6 py-4">Duration</th>
                  <th className="px-6 py-4">Status</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {calls.map((call) => (
                  <tr key={call.call_id} className="hover:bg-gray-50">
                    <td className="px-6 py-4 font-mono text-blue-600">{call.call_id}</td>
                    <td className="px-6 py-4">{call.from_user}@{call.from_domain}</td>
                    <td className="px-6 py-4">{call.to_user}@{call.to_domain}</td>
                    <td className="px-6 py-4">{new Date(call.start_time).toLocaleString()}</td>
                    <td className="px-6 py-4">{call.duration_seconds} sec</td>
                    <td className="px-6 py-4">
                      <span className="bg-green-100 text-green-700 text-xs px-3 py-1 rounded-full">
                        {call.status || "active"}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
}